import { Summary, SummaryResponse } from '../contentqnaPluginTypes';
import { AiTaskInitiationError } from './AiTaskInitiationError';
import { SummaryTaskAlreadyCompletedError } from './SummaryTaskAlreadyCompletedError';

export class SummaryTaskInitiationError extends AiTaskInitiationError {
	private isCompleted = false;
	private task: SummaryResponse | undefined;

	public constructor(public cause?: unknown) {
		super(cause, 'SummaryTaskInitiationError');
		if (cause instanceof SummaryTaskAlreadyCompletedError) {
			this.isCompleted = true;
			this.task = cause.task;
		}
	}

	public isAlreadyCompletedError(): boolean {
		return this.isCompleted;
	}

	public getExistingSummary(): SummaryResponse & {
		summary: Summary;
	} {
		if (!this.task || !this.task.summary) {
			throw new Error('No existing summary found');
		}
		return { ...this.task, summary: this.task.summary };
	}
}
